import React, { useState, useEffect, useRef } from "react";
import { useLanguage } from "../context/LanguageContext";
import { FaLinkedin, FaTwitter, FaGithub, FaPhone } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import imageOrdi from "../assets/images/png/ordi.png";

function About() {
  const { t } = useLanguage();
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="about-section" id="about" ref={ref}>
      <div
        className="about-content"
        style={{
          opacity: visible ? 1 : 0,
          transform: `translateY(${visible ? 0 : 30}px)`,
          transition: "all 0.8s cubic-bezier(0.16,1,0.3,1)",
        }}
      >
        {/* Left — Contact + Image */}
        <div className="about-left" id="contact">
          <p className="section-eyebrow">{t("contactEyebrow")}</p>
          <h2 className="section-title">{t("contactTitle")}<span className="dot">.</span></h2>
          <p className="section-subtitle">{t("contactSubtitle")}</p>

          <img src={imageOrdi} alt="Workspace" className="about-image" />

          <div className="contact-info">
            <div className="contact-row"><FaPhone /> +221 78 430 54 53</div>
            <div className="contact-row"><FaLocationDot /> {t("contactLocation")}</div>
            <div className="contact-row"><MdEmail /> contact@ahmada.dev</div>
          </div>

          <div className="contact-social">
            <a href="https://www.linkedin.com/in/amadou-ngom-8b0103157/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            <a href="https://x.com/_ameahmada_" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://github.com/ameahmada" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
          </div>
        </div>

        {/* Right — About text */}
        <div className="about-bio">
          <p className="section-eyebrow" style={{ textAlign: "left" }}>BIO</p>
          <h2 className="section-title" style={{ textAlign: "left", marginBottom: 20 }}>
            {t("aboutTitle")}<span className="dot">.</span>
          </h2>
          <p>{t("aboutP1")}</p>
          <p>{t("aboutP2")}</p>
        </div>
      </div>
    </section>
  );
}

export default About;
